// extracted by css-extract-rspack-plugin
export default {"root":"root-oDwXCD","skill":"skill-ehH4iQ","name":"name-zF82Bs text-sm"};